<ion-list mode="ios" lines="none" class="list-content">
  <!-- * Titulo -->
  <ion-item mode="md" lines="none" color="white" class="ion-text-center">
    <ion-label
      mode="md"
      color="status-icon-enable"
      class="order-progress mpe-font-weight-600"
    >
      {{ 'Titles.order-progress' | translate }}
    </ion-label>
  </ion-item>

  <!-- * Img -->
  <ion-item mode="md" lines="none" color="white">
    <ion-img [src]="'Icons.cart-time' | translate" class="cart-time"></ion-img>
  </ion-item>

  <!-- * Tiempo -->
  <ion-item mode="md" lines="none" color="white" class="ion-text-center">
    <ion-label
      mode="md"
      color="status-icon-enable"
      class="canmake-neworder-at"
      [innerHTML]="'Labels.canmake-neworder-at' | translate: order | htmlSeguro"
    >
    </ion-label>
  </ion-item>

  <!-- * Disclaimer -->
  <ion-item mode="md" lines="none" color="white" class="ion-text-center">
    <ion-label
      mode="md"
      color="cadet-grey"
      class="for-now-only-edit"
      [innerHTML]="'Labels.for-now-only-edit' | translate | htmlSeguro"
    >
    </ion-label>
  </ion-item>

  <!-- ? Boton Aceptar -->
  <ion-item mode="md" lines="none" color="white">
    <ion-button
      class="button-accept"
      size="default"
      mode="md"
      color="tpcta"
      (click)="onAccept()"
    >
      <ion-label mode="md" class="order-progress mpe-font-weight-600">
        {{ 'Buttons.enderstood' | translate }}
      </ion-label>
    </ion-button>
  </ion-item>

  <!-- * Día entrega -->
  <ion-item
    mode="md"
    lines="none"
    color="white"
    class="ion-text-center item-delivery"
  >
    <ion-label
      mode="md"
      color="cadet-grey"
      class="delivery-will-day"
      [innerHTML]="'Labels.date-of-delivery' | translate: order | htmlSeguro"
      [attr.data-test]="'Automation.txt-cart-delivery-will-day' | translate"
    >
    </ion-label>
  </ion-item>
</ion-list>
